/**
 * This is a combination of a few sub-regexes because of speed. They aren't merged any further to make the code simpler.
 *
 * First part is just this regex (non-capturing group omitted for clarity):
 *
 * ```
 * /(\/\/|\/\*|<!--)\s*(\.\.\.|and)?\s*\(?\s*(((the)?\s*rest\s+of[^\n]+...)|(existing\s+(...))/gi
 * ```
 *
 * This matches in order:
 *
 *  1. The start of a comment (could incorrectly match inside a string literal but we'll ignore that issue for now)
 *  2. And optional `...` or `and`
 *  3. A `The Rest of ...` pattern or `existing ...` pattern
 *
 * The second part is:
 *
 * ```
 * /((\/\/|\/\*|<!--)\s*(\.\.\.)[^\.\n]+\s*(\.\.\.)?))/gi
 * ```
 *
 * This matches in order:
 *
 *  1. The start of a comment
 *  2. Any text between ... and an optional ...
 *
 * The best way to reason about this regex is to look at it through a tool like https://regexr.com.
 */
const LAZINESS_REGEX =
  /(?:(?:(?:\/\/|\/\*|<!--|\[|#)\s*(?:\.\.\.|and)?\s*\(?\s*(?:(?:(the)?\s*rest\s+of.*?(?:implementation|function|component|code|style|content|file))|(?:(?:keep|(?:other)?\s+existing|.*?remains?)(?:\s+existing|\s+content|.*?\s+(?:the\s+same|function|code|rules|unchanged))|(?:previous\s+imports))))|(?:(?:\/\/|\/\*|<!--)\s*(?:\.\.\.).+?(?:\.\.\.)))/gi;

/**
 * Check if a file content generated by the AI is "lazy", meaning
 * that instead of providing the full file content the AI, used
 * comment markers to say that the "rest of the code remains the same".
 *
 * Based on the issues reported we take a simple approach that should
 * match the most common use cases.
 *
 * @param fileContent File content generated by the AI.
 */
export function isLikelyToBeLazy(fileContent: string): boolean {
  return !!fileContent.match(LAZINESS_REGEX);
}
